import { assign, flow, get, isFunction, isNull, isUndefined, keys, mapValues, omit, omitBy, partialRight } from 'lodash';
import { apiActionCreator } from '../actions/actions';

const defaultNextActionMapper = (reqAction, requestConfig, error, response) => ({
  timestamp: Date.now(),
  meta: reqAction.meta,
  requestAction: reqAction,
  request: requestConfig,
  response: (response && response.data) || (error && error.response),
  error: error && error.message,
  ...getActionCustomFields(reqAction),
});

const getActionCustomFields = (origAction) => omit(origAction, keys(apiActionCreator({})));

const cleanParams = (params) => omitBy(params, (val) => isUndefined(val) || isNull(val));
const generateHeaders = (store, headersMap) =>
  flow(
    partialRight(omitBy, (headerValue) => headerValue === undefined),
    partialRight(mapValues, (value) => (isFunction(value) ? value(store) : value))
  )(headersMap);

export const callbacksGeneratorBuilder = (dispatch, nextActionMapper = defaultNextActionMapper) => (reqAction, requestConfig) => ({
  onPending: () =>
    dispatch({
      ...nextActionMapper(reqAction, requestConfig),
      type: reqAction.payload.nextType.PENDING,
    }),
  onSuccess: (response) =>
    dispatch({
      ...nextActionMapper(reqAction, requestConfig, null, response),
      type: reqAction.payload.nextType.SUCCESS,
    }),
  onFailure: (error) =>
    dispatch({
      ...nextActionMapper(reqAction, requestConfig, error),
      type: reqAction.payload.nextType.FAILURE,
    }),
  onCancel: (error) =>
    dispatch({
      ...nextActionMapper(reqAction, requestConfig, error),
      type: reqAction.payload.nextType.CANCELLED,
    }),
});

export const generateRequestConfig = (
  state,
  { type, payload: { method, url, params, body, headers, withCredentials, nextType, responseType, ...restPayload } },
  headersMap
) => ({
  method: method.toLowerCase(),
  url: isFunction(url) ? url(state) : url,
  params: cleanParams(params),
  data: body,
  headers: generateHeaders(state, assign({}, headersMap, headers)),
  withCredentials,
  type: (nextType && nextType.TYPE) || type,
  responseType,
  ...restPayload,
});

export const generateCancelRequestConfig = (store, action, headersMap) =>
  get(action, 'predicate') ? { predicate: action.predicate } : generateRequestConfig(store, action, headersMap);
